{
  "action": "#2970ff",
  "baseGray": "#333",
  "bgAction": "#dceaff",
  "bgGray": "#fcfcfc",
  "borderGray": "#e5e5e5",
  "borderHoverGray": "#ccc",
  "dark": "#0c1e3e",
  "darkGray": "#aaa",
  "disabledGray": "#f5f5f5",
  "empty": "#999",
  "error": "#d0021b",
  "errorDark": "#C0021B",
  "lightGray": "#f2f2f2",
  "main": "#ffbe00",
  "mainDark": "#e5ac00",
  "mainDarker": "#cc9900",
  "mainLight": "#FFDD7A",
  "mainLightest": "#faf3e0",
  "medGray": "#666",
  "normal": "#0c1e3e",
  "organization": "var(--organization)",
  "paleAction": "#f4f8ff",
  "paleError": "#FAE6E8",
  "paleMain": "#FFF0C5",
  "paleSuccess": "#CCF8EC",
  "purple": "#9747FF",
  "success": "#2ed6a1",
  "successDark": "#2CCE9C",
  "transparent": "transparent",
  "white": "#fff"
}
